import type { RouteRecordRaw } from 'vue-router';
import { additionalAccountsLevelGuard } from '@/shared/additionalAccounts/router/additionalAccountsLevel.guard';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const AdditionalWalletDetailPage = () => import('../pages/AdditionalWalletDetail/index.vue');

/**
 * Vive en `wallet/router/`, no en `additionalAccounts/router/`, porque la
 * page reusa la lógica real de `wallet` (WalletDetailHeader, getCardButtons)
 * — un router de `additionalAccounts` no puede importar un componente de
 * `wallet` (crossModule). El nombre de ruta `additional-account-detail` no
 * cambió, así que los call-sites existentes no requieren ningún ajuste.
 *
 * El padre es '/' y el child lleva el path COMPLETO a propósito: duplicar el
 * padre `/gestion/cuentas` (que ya declara `additionalAccounts.private.route.ts`)
 * hace que vue-router matchee este record —registrado primero— para el path
 * exacto de la página de gestión y renderice MainLayout vacío.
 */
export const additionalWalletDetailRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: 'gestion/cuentas/:walletId',
        name: 'additional-account-detail',
        component: AdditionalWalletDetailPage,
        beforeEnter: additionalAccountsLevelGuard,
        meta: {
          requiresAuth: true,
          flag: 'feature_multi_accounts_b2b',
          title: 'Detalle de cuenta secundaria',
        },
      },
    ],
  },
];
